import React from "react";
import useScrollAnimation from "../components/useScrollAnimation";


const projects = [
  {
    title: "Task Manager – Django Web App",
    description:
      "A full-stack task management web application built with Django that allows users to create, track, and manage daily tasks with a clean and distraction-free interface.",
    tech: ["Python", "Django", "SQLite", "Gunicorn", "WhiteNoise", "HTML", "CSS", "JavaScript"],
    points: [
      "Implemented user authentication with register, login, and logout functionality",
      "Built full CRUD operations for tasks including title, description and due dates",
      "Developed a soft-delete Recycle Bin system allowing users to restore",
      "Added task status tracking to mark tasks as complete or incomplete and monitor daily progress",
      "Configured static file serving with WhiteNoise and deployed the application on Render",
    ],
    github: "https://github.com/Dhanashree-Raut/Task-Manager-Django",
    demo: "https://task-manager-django-dncm.onrender.com",
  },
  {
    title: "NovaWeb Solutions – Django Service Website",
    description:
      "A professional service-based website built with Django that showcases web development services, company information, and a contact system.",
    tech: ["Python", "Django", "Bootstrap", "JavaScript", "HTML", "CSS"],
    points: [
      "Developed a multi-page service website including Home, About, Services, and Contact pages",
      "Implemented responsive UI using Bootstrap for modern layout and mobile compatibility",
      "Built a contact form that stores user inquiries in the database and displays messages in Django Admin",
      "Added smooth scroll animations and interactive UI elements to enhance user experience",
      "Configured static file handling with WhiteNoise and deployed the application on Render"
    ],
    github: "https://github.com/Dhanashree-Raut/NovaWeb-Solutions-Django",
    demo: "https://novaweb-solutions-django.onrender.com/",
  },
  {
    title: "InfynieNews",
    description:
      "A React-based news application with category-wise filtering using external APIs.",
    tech: ["React", "News API", "Bootstrap"],
    points: [
      "Fetched and displayed live news using external APIs",
      "Implemented category-wise filtering with responsive UI",
      "Handled loading states and API error scenarios",
      "Added infinite scroll functionality for smooth, dynamic content loading",
    ],
    github: "https://github.com/Dhanashree-Raut/News-Application---InfynieNews",
    demo: "https://news-application-infynienews.onrender.com",
  },

  {
    title: "TextTools – React Text Utility App",
    description:
      "A React-based text utility application that allows users to transform and analyze text efficiently.",
    tech: ["React", "JavaScript", "Bootstrap", "CSS"],
    points: [
      "Implemented text transformations such as uppercase, lowercase, and sentence case",
      "Added real-time text analysis including word, character, sentence, and paragraph count",
      "Built light and dark mode toggle for improved readability",
      "Enabled copy-to-clipboard functionality with user feedback",
    ],
    github: "https://github.com/Dhanashree-Raut/TextToolkit",
    demo: "https://texttoolkit-1-xjb5.onrender.com",
  },


  {
    title: "Todo List App (LocalStorage)",
    description:
      "A simple and efficient Todo List application that allows users to add and delete tasks with data persistence using browser localStorage.",
    tech: ["HTML", "CSS", "JavaScript", "LocalStorage"],
    points: [
      "Implemented add and delete functionality for managing daily tasks",
      "Used browser localStorage to persist todo data across page refresh",
      "Handled dynamic DOM updates for real-time task management",
      "Designed a clean and minimal UI for better usability",
    ],
    github: "https://github.com/Dhanashree-Raut/To-Do-List",
    demo: "https://dhanashree-raut.github.io/To-Do-List/",
  },
  {
    title: "Todo List Web App (Flask & SQLite)",
    description:
      "A backend-driven Todo List web application built with Flask that allows users to add, update, and delete tasks with persistent storage using SQLite.",
    tech: ["Python", "Flask", "SQLAlchemy", "SQLite", "HTML", "CSS"],
    points: [
      "Implemented CRUD operations using Flask routes",
      "Used SQLAlchemy ORM to manage task data with SQLite database",
      "Handled form submissions and server-side rendering with Jinja templates",
      "Implemented update and delete functionality using dynamic URL routing",
    ],
    github: "https://github.com/Dhanashree-Raut/ToDo/tree/main", // update if repo exists
    demo: "https://todo-1-9vc7.onrender.com", // add live link if hosted
  }
  ,


  {
    title: "Spotify UI Clone",
    description:
      "A dark-themed Spotify UI clone built using modern CSS layout techniques.",
    tech: ["HTML", "CSS"],
    points: [
      "Implemented dark theme with clean and minimal UI",
      "Used modern CSS for layout and styling",
      "Ensured responsiveness across devices",
    ],
    github: "https://github.com/Dhanashree-Raut/Spotify-UI-Clone",
    demo: "https://dhanashree-raut.github.io/Spotify-UI-Clone/",
  },
  {
    title: "Instagram UI Clone",
    description:
      "A responsive Instagram UI clone with stories, posts, and sidebar layout.",
    tech: ["HTML", "CSS"],
    points: [
      "Built responsive layout using Flexbox and Grid",
      "Designed reusable UI components for posts and stories",
      "Focused on visual consistency and mobile responsiveness",
    ],
    github: "https://github.com/Dhanashree-Raut/Instagram-Ui-Clone",
    demo: " https://dhanashree-raut.github.io/Instagram-Ui-Clone/",
  },
  {
    title: "Sudoku Solver using Python",
    description:
      "A Python-based Sudoku solver that uses the backtracking algorithm to automatically solve a 9x9 Sudoku puzzle.",
    tech: ["Python", "NumPy", "Backtracking Algorithm"],
    points: [
      "Implemented backtracking algorithm to solve Sudoku puzzles efficiently",
      "Validated number placement using row, column, and 3x3 grid constraints",
      "Handled recursive solution finding with proper backtracking",
      "Displayed solved Sudoku grid in matrix format using NumPy",
    ],
    github: "https://github.com/Dhanashree-Raut/Sudoku-game", // update if repo exists
  }
  ,
  {
    title: "SQL Query Runner in Java (JDBC)",
    description:
      "A Java-based desktop application that allows users to execute SQL DML and DQL queries and view results through a graphical interface.",
    tech: ["Java", "AWT", "JDBC", "SQL"],
    points: [
      "Built a Java AWT-based GUI to accept and execute SQL queries",
      "Implemented JDBC connectivity to interact with MS Access database",
      "Handled DML queries (INSERT, UPDATE, DELETE) with affected row count",
      "Executed DQL queries (SELECT) and displayed results dynamically",
      "Added query validation and error handling for invalid SQL inputs",
    ],
    github: "https://github.com/Dhanashree-Raut/Projret-to-run-SQL-queries-in-JAVA",
  }

];

/* ================= SINGLE PROJECT COMPONENT ================= */

function ProjectItem({ project, index }) {
  const ref = useScrollAnimation();

  const shouldAnimate = index > 5; // Skip first 3

  return (
    <div
      ref={shouldAnimate ? ref : null}
      className={`col-md-4 mb-4 ${shouldAnimate ? "scroll-hidden" : ""}`}
    >
      <div className="card h-100 p-4 project-card d-flex flex-column">

        <h5 className="fw-bold">{project.title}</h5>

        <p className="small">{project.description}</p>

        <div className="mb-3">
          {project.tech.map((tech, i) => (
            <span key={i} className="badge bg-secondary me-1 mb-1">
              {tech}
            </span>
          ))}
        </div>

        <ul className="small ps-3 mb-4">
          {project.points.map((point, i) => (
            <li key={i}>{point}</li>
          ))}
        </ul>

        <div className="mt-auto">
          <a
            href={project.github}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline-light btn-sm me-2"
          >
            GitHub
          </a>

          {project.demo && (
            <a
              href={project.demo}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-light btn-sm"
            >
              Live Demo
            </a>
          )}
        </div>

      </div>
    </div>
  );
}

/* ================= MAIN PROJECT PAGE ================= */

export default function Projects() {
  return (
    <div className="container mt-5 pt-5">
      <h2 className="fw-bold mb-5">Projects</h2>

      <div className="row">
        {projects.map((project, index) => (
          <ProjectItem
            key={index}
            project={project}
            index={index}
          />
        ))}
      </div>
    </div>
  );
}